import storage from 'good-storage'
import { APP_NAME } from './config'

class Cache {
  constructor (key, session = false) {
    if (session) {
      this.storage = storage.session
    } else {
      this.storage = storage
    }
    this.key = key
  }

  get () {
    return this.storage.get(this.key, null)
  }

  set (value) {
    this.storage.set(this.key, value)
  }

  remove () {
    this.storage.remove(this.key)
  }
}

const prefix = APP_NAME + VERSION + '_'

const openidKey = prefix + 'openid'
/**
 * openid
 * @type {Cache}
 */
export const openidCache = new Cache(openidKey)

const dataKey = prefix + 'data'
/**
 * 通用data传参
 * @type {Cache}
 */
export const dataCache = new Cache(dataKey, true)
/**
 * 通用data传参
 * @type {Cache}
 */
const userKey = prefix + 'user'
export const userCache = new Cache(userKey)

const bookDeptKey = prefix + 'book_dept'
export const bookDeptCache = new Cache(bookDeptKey)

const orderTimeKey = prefix + 'order_time'
export const orderTimeCache = new Cache(orderTimeKey)

const docCache = 'DOC_CACHE'
export const DocCache = new Cache(docCache)

const cacheDate = 'CACHE_DATE'
export const DateCache = new Cache(cacheDate)

const cacheHos = 'HOS_CACHE'
export const HosCache = new Cache(cacheHos)

/**
 * 选择就诊人
 */
const patientInfo = prefix + 'patient'
export const patientInfoCache = new Cache(patientInfo, true)

/**
 * 搜索历史记录
 * @type {string}
 */
const searchHistoryKey = prefix + 'search_history'
const bookSearchHistoryKey = prefix + 'book_search_history'
const audioSearchHistoryKey = prefix + 'audio_search_history'
const onlineSearchHistoryKey = prefix + 'online_search_history'
const articleHistoryKey = prefix + 'article_search_historyKey'
const medicalHistoryKey = prefix + 'medical_search_historyKey'
const smartsDeptHistoryKey = prefix + 'smarts_dept_search_historyKey'
const mapDeptHistoryKey = prefix + 'map_dept_search_historyKey'
class SearchHistoryCache extends Cache {
  set (value) {
    if (typeof value === 'object') {
      this.storage.set(this.key, value)
    } else {
      let his = this.get() || []
      let index = his.findIndex(r => r === value)
      if (index >= 0) {
        his.splice(index, 1)
      }
      his.unshift(value)
      this.storage.set(this.key, his.slice(0, 10))
    }
  }
}

export const searchHistoryCache = new SearchHistoryCache(searchHistoryKey)
export const bookSearchHistoryCache = new SearchHistoryCache(bookSearchHistoryKey)
export const audioSearchHistoryCache = new SearchHistoryCache(audioSearchHistoryKey)
export const onlineSearchHistoryCache = new SearchHistoryCache(onlineSearchHistoryKey)
export const articleHistoryCache = new SearchHistoryCache(articleHistoryKey)
export const medicalHistoryCache = new SearchHistoryCache(medicalHistoryKey)
export const smartsDeptHistoryCache = new SearchHistoryCache(smartsDeptHistoryKey)
export const mapDeptHistoryCache = new SearchHistoryCache(mapDeptHistoryKey)




/**
 * 地区关系列表
 * @type {string}
 */
const areaArrayKey = 'GBAREA'
class AreaCache extends Cache {
  set (areaArray, weekNum) {

    let gbObj = {
      province_list: {},
      city_list: {},
      county_list: {}
    }
    for(let province of areaArray){
      gbObj.province_list[province.id] = province.areaName
      for(let city of province.subSysArea){
        gbObj.city_list[city.id] = city.areaName
        for(let country of city.subSysArea){
          gbObj.county_list[country.id] = country.areaName
        }
      }
    }

    let gbArea=[];
    for(let province of areaArray){
      let provinceItem = [province.id, province.areaName, province.areaLevel];
      gbArea.push(provinceItem);
      for(let city of province.subSysArea){
        let cityItem = [city.id, city.areaName, city.areaLevel, province.id];
        gbArea.push(cityItem);
        for(let country of city.subSysArea){
          let countryItem = [country.id, country.areaName, country.areaLevel, city.id];
          gbArea.push(countryItem);
        }
      }
    }

    let AreaObj = {
      version: weekNum,
      gbArea: gbArea,
      gbObj: gbObj
    }

    this.storage.set(this.key, AreaObj)
  }

  get () {
    return this.storage.get(this.key)||null
  }
}
export const areaCache = new AreaCache(areaArrayKey)





// WEBPACK FOOTER //
// ./src/lib/cache.js